<template>
    <div class="structured-claims-editor">
        <BAlert v-if="!claims.length" variant="light-secondary" show class="mb-0">
            <div class="alert-body">
                {{ translate('Component(ResearchReviewProcess):no-claims', 'No claims were extracted for this legislation.') }}
            </div>
        </BAlert>

        <div
            v-for="(claim, claimIndex) in claims"
            :key="`claim-${claimIndex}`"
            class="structured-claims-editor__claim"
        >
            <div class="structured-claims-editor__claim-grid">
                <BFormGroup
                    :label="translate('Component(ResearchReviewProcess):claim-type', 'Claim type')"
                    class="mb-0"
                >
                    <VSelect
                        :value="selectedOption(claimTypeOptions, claim.type)"
                        :options="claimTypeOptions"
                        label="label"
                        :clearable="false"
                        :append-to-body="true"
                        @input="updateClaim(claimIndex, 'type', $event ? $event.id : null)"
                    />
                </BFormGroup>
                <BButton
                    type="button"
                    variant="flat-danger"
                    class="btn-icon structured-claims-editor__claim-remove"
                    :title="translate('Component(Button):remove', 'Remove')"
                    @click="removeClaim(claimIndex)"
                >
                    <FeatherIcon icon="Trash2Icon" size="16" />
                </BButton>
            </div>
            <BFormGroup
                :label="translate('Component(ResearchReviewProcess):evidence', 'Evidence')"
                class="mb-0 mt-75"
            >
                <BFormTextarea
                    :value="claim.evidence"
                    rows="2"
                    max-rows="4"
                    :placeholder="translate('Component(ResearchReviewProcess):claim-evidence-placeholder', 'Text supporting this claim')"
                    @input="updateClaim(claimIndex, 'evidence', $event || null)"
                />
            </BFormGroup>
        </div>
    </div>
</template>

<script>
import {
    BAlert,
    BButton,
    BFormGroup,
    BFormTextarea,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { CLAIM_TYPES } from '../regulation-review-options'

export default {
    name: 'StructuredClaimsEditor',
    components: {
        BAlert,
        BButton,
        BFormGroup,
        BFormTextarea,
        VSelect,
    },
    props: {
        claims: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        claimTypeOptions() {
            return CLAIM_TYPES.map(value => ({
                id: value,
                label: this.translate(
                    `Component(ResearchReviewProcessEnum):claim-type-${value}`,
                    this.humanize(value),
                ),
            }))
        },
    },
    methods: {
        translate(key, fallback) {
            const translation = this.$t(key)

            return translation && translation !== key ? translation : fallback
        },
        humanize(value) {
            return String(value || '').replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase())
        },
        selectedOption(options, value) {
            return options.find(option => option.id === value) || null
        },
        withoutValues(claims) {
            return claims.map(claim => {
                const normalized = { ...claim }
                delete normalized.value
                return normalized
            })
        },
        updateClaim(index, key, value) {
            this.$emit('input', this.withoutValues(this.claims.map((claim, claimIndex) => (
                claimIndex === index ? { ...claim, [key]: value } : claim
            ))))
        },
        removeClaim(index) {
            this.$emit('input', this.withoutValues(
                this.claims.filter((claim, claimIndex) => claimIndex !== index),
            ))
        },
    },
}
</script>

<style lang="scss" scoped>
.structured-claims-editor__claim {
    padding: .75rem;
    margin-bottom: .75rem;
    border: 1px solid #ebe9f1;
    border-radius: .357rem;
}

.structured-claims-editor__claim-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: .75rem;
    align-items: end;
}

.structured-claims-editor__claim-remove {
    margin-bottom: .15rem;
}
</style>
